import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { Button } from 'dibs-elements/exports/Button';

import styles from './styles.scss';

type Props = {
    conversationLinkHref?: string;
};

const CallInitiatedSuccess: FC<Props> = ({ conversationLinkHref = '/inbox/' }) => {
    return (
        <div className={styles.prompt}>
            <FormattedMessage
                id="dc.buyerInitiateCall.messageSeller"
                defaultMessage="No answer? Message the seller to schedule another time to call."
            />
            <Button
                className={styles.button}
                dataTn="go-to-conversation-button"
                onClick={() => {
                    window.location.assign(conversationLinkHref);
                }}
                fullWidth
            >
                <FormattedMessage
                    id="dc.buyerInitiateCall.goToConversation"
                    defaultMessage="Go to Conversation"
                />
            </Button>
        </div>
    );
};

export default CallInitiatedSuccess;
